import React, { useEffect } from "react";
import { Form, Input, Button, Row, Col, Select, DatePicker } from "antd";

const ReturnPrincipleCreationForm = ({
  form,
  userData,
  counterData,
  handleFormSubmit,
  onSenderChange,
  disableSender,
}) => {
  useEffect(() => {
    if (form) {
      const randomNumbers = Math.floor(10000000 + Math.random() * 90000000);
      form.setFieldsValue({ noForm: `RP${randomNumbers}` });
    }
  }, [form]);
  return (
    <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12}>
          <Form.Item
            label="No Nota Return"
            name="noForm"
            rules={[
              { required: true, message: "Please input Shipping Number!" },
            ]}
          >
            <Input type="text" onWheel={(e) => e.target.blur()} disabled />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            label="No Form Penjualan"
            name="noSJ"
            rules={[
              { required: true, message: "Please input Shipping Number!" },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12}>
          <Form.Item
            label="Kirim dari"
            name="sender"
            initialValue={userData.counterCode}
            rules={[{ required: true, message: "Please select a Counter!" }]}
          >
            <Select
              disabled={disableSender}
              onChange={(value) => {
                // Call the onSenderChange callback to notify parent component
                if (onSenderChange) onSenderChange(value);
                form.setFieldsValue({ sender: value });
              }}
              showSearch
              placeholder="Select a Counter"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {counterData
                .filter((counter) => counter.code !== "PRI")
                .map((counter) => (
                  <Select.Option key={counter.code} value={counter.code}>
                    {counter.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>{" "}
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            label="Kirim ke"
            name="destination"
            initialValue={"PRI"}
            rules={[{ required: true, message: "Please select a Counter!" }]}
          >
            <Select
              showSearch
              placeholder="Select a Counter"
              disabled
              onChange={(value, option) => {
                form.setFieldsValue({ destinationCode: option.code });
              }}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {counterData
                .filter((counter) => counter.code !== userData.counterCode)
                .map((counter) => (
                  <Select.Option
                    key={counter.code}
                    value={counter.code}
                    code={counter.code}
                  >
                    {counter.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name="destinationCode" hidden>
        <Input />
      </Form.Item>

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12}>
          <Form.Item label="Alasan Return" name="keterangan">
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={6}>
          <Form.Item
            label="Tanggal Kirim"
            name="tanggal_kirim"
            rules={[
              { required: true, message: "Please select Tanggal Kirim!" },
            ]}
          >
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={6}>
          <Form.Item
            label="Tanggal Terima ETA"
            name="tanggal_terima_eta"
            rules={[
              {
                required: true,
                message: "Please select Tanggal Terima ETA!",
              },
            ]}
          >
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12}>
          <Form.Item label="Total Value" name="totalCost" hidden>
            <Input prefix="Rp." disabled />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item label="Total Pasang" name="totalQuantity">
            <Input disabled />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default ReturnPrincipleCreationForm;
